<template>
    <div>
        <!-- FASE 4 / BLOCO AA — DOC 20, 46, 47 -->

        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24">
                <el-alert type="info" :closable="false" show-icon
                          title="Itens excluídos ficam aqui e podem ser restaurados."
                          description="Restaurar uma pasta traz de volta as subpastas e os documentos que foram para a lixeira junto com ela.">
                </el-alert>
            </el-col>
        </el-row>

        <el-divider content-position="left">Pastas na lixeira</el-divider>

        <div class="container-table u-mb-30" v-loading="!statusPastas">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:40px"></th>
                        <th>Caminho</th>
                        <th class="hidden-mobile u-text-center" style="width:150px">Excluída em</th>
                        <th class="u-text-center" style="width:130px">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="p in pastas" :key="'p'+p.id">
                        <td class="u-text-center"><i class="el-icon-folder-delete" style="color:#E6A23C"></i></td>
                        <td>{{ p.caminho }}</td>
                        <td class="hidden-mobile u-text-center">{{ p.deleted_at | formatarData }}</td>
                        <td class="u-text-center acao">
                            <el-button type="success" icon="el-icon-refresh-left" size="mini" plain
                                       title="Restaurar" @click="restaurarPasta(p)">RESTAURAR</el-button>
                        </td>
                    </tr>
                    <tr v-if="!pastas.length && statusPastas">
                        <td colspan="4" class="u-text-center u-mt-25">Nenhuma pasta na lixeira.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <el-divider content-position="left">Documentos na lixeira</el-divider>

        <div class="container-table" v-loading="!statusDocs">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:40px"></th>
                        <th>Título</th>
                        <th class="hidden-mobile u-text-center" style="width:150px">Excluído em</th>
                        <th class="u-text-center" style="width:130px">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="d in documentos" :key="'d'+d.id">
                        <td class="u-text-center"><i class="el-icon-document-delete" style="color:#F56C6C"></i></td>
                        <td>{{ d.titulo }}</td>
                        <td class="hidden-mobile u-text-center">{{ d.deleted_at | formatarData }}</td>
                        <td class="u-text-center acao">
                            <el-button type="success" icon="el-icon-refresh-left" size="mini" plain
                                       title="Restaurar" @click="restaurarDocumento(d)">RESTAURAR</el-button>
                        </td>
                    </tr>
                    <tr v-if="!documentos.length && statusDocs">
                        <td colspan="4" class="u-text-center u-mt-25">Nenhum documento na lixeira.</td>
                    </tr>
                </tbody>
            </table>

            <el-row :gutter="10" v-if="statusDocs">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                       @current-change="getPagePagination" :page-size="30" background
                                       layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-row class="u-mt-20">
            <el-col :xs="24">
                <el-button type="default" icon="el-icon-back" @click="$router.push('/admin/documento')">
                    VOLTAR AOS DOCUMENTOS
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        statusPastas: false,
        statusDocs: false,
        pastas: [],
        documentos: [],
        paginate: { page: 1, qtdItens: 0, from: '', to: '' }
    }),
    mounted () {
        this.carregarPastas()
        this.carregarDocumentos()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const resp = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (resp && typeof resp.erro === 'string') msg = resp.erro
            else if (resp && resp.erro && resp.erro.text) msg = resp.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregarPastas () {
            this.statusPastas = false
            this.$axios.post(`${this.base()}/api/documento-pasta/lixeira`, {}, this.auth()).then(r => {
                this.pastas = r.data
                this.statusPastas = true
            }).catch(e => { this.statusPastas = true; this.erro(e) })
        },

        carregarDocumentos () {
            this.statusDocs = false
            this.$axios.post(`${this.base()}/api/documento/lixeira?page=${this.paginate.page}`,
                {}, this.auth()).then(r => {
                this.documentos = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusDocs = true
            }).catch(e => { this.statusDocs = true; this.erro(e) })
        },

        restaurarPasta (p) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-pasta/restaurar/${p.id}`, {}, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Pasta restaurada.', type: 'success' })
                this.carregarPastas(); this.carregarDocumentos()
            }).catch(e => { this.erro(e) })
        },

        restaurarDocumento (d) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento/restaurar/${d.id}`, {}, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Documento restaurado.', type: 'success' })
                this.carregarDocumentos()
            }).catch(e => { this.erro(e) })
        },

        getPagePagination (page) { this.paginate.page = page; this.carregarDocumentos() }
    },
    components: {  }
}
</script>
